import "swiper/swiper-bundle.css";

import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll(".js-awards-swiper.swiper")).map(
	(hero) => {
		const swiper = new Swiper(hero, {
			slidesPerView: 1.5,
			spaceBetween: 24,
			modules: [Autoplay, Pagination],
			centeredSlides: true,
			autoplay: {
				delay: 3500,
			},
			loop: true,
			breakpoints: {
				768: {
					slidesPerView: 4,
					spaceBetween: 40,
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 72,
				},
			},
		});
	}
);
